// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j7-3";
export var downloadButton = "_j7-4";
export var fileContainer = "_j7-9 _j7-7";
export var fileContainerBase = "_j7-7";
export var fileContainerFixedHeight = "_j7-8 _j7-7";
export var fileInfo = "_j7-5";
export var fileInfoWidthRestricted = "_j7-6";
export var fileType = "_j7-1";
export var fileTypeName = "_j7-2";
export var image = "_j7-0";
export var link = "_j7-b";
export var overflowEllipsis = "_j7-a";